// Components/ui
import { TextField, Typography } from '@mui/material';
import { InputContainer } from '../../layout';
// Types
import { UseFieldType } from '../../hooks/useField';
import { useTranslationContext } from '../../context/TranslationContext';

type DescriptionTextFieldProps = {
  descriptionField: UseFieldType;
  disabled: boolean;
};

const DescriptionTextField = ({ descriptionField, disabled }: DescriptionTextFieldProps) => {
  const t = useTranslationContext();
  // Extraer type y value para evitar conflictos con multiline
  const { value, type, ...restAttributes } = descriptionField.attributes;
  const safeValue = value || '';

  // Modo vista: mostrar como texto estático
  if (disabled) {
    return (
      <InputContainer title={t('global.description')}>
        <Typography variant="body2" sx={{ py: 0.5, whiteSpace: 'pre-wrap', color: (theme) => theme.palette.text.secondary, fontSize: '0.9rem' }}>
          {safeValue || '-'}
        </Typography>
      </InputContainer>
    );
  }

  return (
    <InputContainer title={t('global.description')}>
      <TextField
        {...restAttributes}
        value={safeValue}
        disabled={disabled}
        size="small"
        multiline
        maxRows={5}
        fullWidth
        variant="outlined"
        // No pasar type cuando es multiline para evitar conflictos
      />
    </InputContainer>
  );
};

export default DescriptionTextField;
